import { gsap } from "gsap";

/**
 * Lang switcher: toggle del dropdown al click sul cerchio.
 *
 * Comportamenti:
 *  - Click sul bottone: toggle classe .is-open + animazione GSAP (fade + slideDown)
 *  - Click fuori dal componente: chiusura
 *  - Tasto ESC: chiusura + focus back sul bottone
 *  - aria-expanded sincronizzato con stato visibile
 */

const ANIMATION_DURATION = 0.2;

const initLangSwitcher = () => {
  const switchers = document.querySelectorAll("[data-lang-switcher]");
  if (!switchers.length) return;

  switchers.forEach(setupSwitcher);
};

const setupSwitcher = (switcher) => {
  const toggle = switcher.querySelector("[data-lang-toggle]");
  const dropdown = switcher.querySelector("[data-lang-dropdown]");
  if (!toggle || !dropdown) return;

  // Stato iniziale GSAP: nascosto (allineato a SCSS)
  gsap.set(dropdown, { opacity: 0, y: -8 });

  const openDropdown = () => {
    switcher.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    gsap.to(dropdown, {
      opacity: 1,
      y: 0,
      duration: ANIMATION_DURATION,
      ease: "power2.out",
    });
  };

  const closeDropdown = (returnFocus = false) => {
    if (!switcher.classList.contains("is-open")) return;
    switcher.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    gsap.to(dropdown, {
      opacity: 0,
      y: -8,
      duration: ANIMATION_DURATION,
      ease: "power2.in",
    });
    if (returnFocus) toggle.focus();
  };

  // Toggle al click sul cerchio
  toggle.addEventListener("click", (e) => {
    e.stopPropagation();
    if (switcher.classList.contains("is-open")) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  // Click fuori dal componente → chiude
  document.addEventListener("click", (e) => {
    if (!switcher.contains(e.target)) {
      closeDropdown();
    }
  });

  // ESC → chiude + ridà focus al bottone
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && switcher.classList.contains("is-open")) {
      closeDropdown(true);
    }
  });
};

export default () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLangSwitcher);
  } else {
    initLangSwitcher();
  }
};
